export default __webpack_public_path__ + "static/media/kal-visuals-square.3210e28a.jpg";